import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getFirstSentenceByStatus } from '../utils/dao';
import { SentenceStatus } from '../models/db_models';

function QuizRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const findAndRedirect = async () => {
      if (!id) {
        setError('No collection ID provided');
        return;
      }

      try {
        // Find the first TODO sentence
        const todoSentence = await getFirstSentenceByStatus(id, SentenceStatus.TODO);

        if (todoSentence) {
          // Redirect to the specific sentence
          navigate(`/collection/${id}/sentence/${todoSentence.id}`, { replace: true });
        } else {
          setError('No TODO sentences found. All sentences completed!');
        }
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
      }
    };

    findAndRedirect();
  }, [id, navigate]);

  if (error) {
    return (
      <div className="container text-center mt-5">
        <p className="text-danger">{error}</p>
        <p className="mt-4">
          <Link to={`/collection/${id}`} className="text-primary">← Back to Collection</Link>
        </p>
      </div>
    );
  }

  return (
    <div className="container text-center mt-5">
      <div className="spinner-border" role="status">
        <span className="visually-hidden">Finding next sentence...</span>
      </div>
      <p className="mt-3">Finding next sentence...</p>
    </div>
  );
}

export default QuizRedirect;
